export default function PROFILE(){

  const insertNav = nav => {
    const header_nav = $('<div class="block_head" />').append(nav)[0]
    const footer_nav = $('<div class="block_foot" />').append(nav)[0]
    $('#main').prepend(header_nav)
    $('#main').append(footer_nav)
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
  }
  $.get('/asset/html/about-nav.html').done(insertNav)
}